// Light/dark choice for the admin panel. Until someone uses the navbar switch the panel follows
// the device's colour scheme; after that their choice is kept in this browser.
// Storage can throw (private windows, blocked site data), so every access is guarded.

export const THEME_STORAGE_KEY = "panelThemeMode";

const DARK_QUERY = "(prefers-color-scheme: dark)";

const systemQuery = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(DARK_QUERY)
    : null;

// true / false for a saved choice, null when nobody has chosen (or storage is unavailable).
export function getSavedDarkMode() {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === "dark") return true;
    if (saved === "light") return false;
  } catch (e) {
    // fall through to "no choice"
  }
  return null;
}

export function getInitialDarkMode() {
  const saved = getSavedDarkMode();
  if (saved !== null) return saved;
  return Boolean(systemQuery()?.matches);
}

export function saveDarkMode(dark) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, dark ? "dark" : "light");
  } catch (e) {
    // the switch still works for this visit
  }
}

// Calls onChange(isDark) when the device scheme flips, but only while no choice is saved.
// Returns an unsubscribe function.
export function watchSystemDarkMode(onChange) {
  const query = systemQuery();
  if (!query || typeof query.addEventListener !== "function") return () => {};
  const handler = (event) => {
    if (getSavedDarkMode() === null) onChange(event.matches);
  };
  query.addEventListener("change", handler);
  return () => query.removeEventListener("change", handler);
}
